import { Grid, Box } from '@domain-group/suit-theme'

import TemplateTasksOverview from './components/TemplateTasksOverview'
import StatisticWithGraph from './components/StatisticWithGraph'

interface StatisticsProps {
  teamId: number,
}

const Statistics = (props: StatisticsProps) => {
  const { teamId } = props

  return (
    <Box flexDirection="column" flexShrink="0" marginBottom="large">
      <Grid
        gridGap="large"
        gridAutoRows="1fr"
        gridTemplateColumns="repeat(auto-fit, minmax(260px, 3fr))"
        gridTemplateRows="repeat(auto-fill, minmax(155px, 1fr))"
      >
        <TemplateTasksOverview teamId={teamId} />

        <StatisticWithGraph
          description="Total Completed (Week)"
          datePeriod="week"
          teamId={teamId}
        />

        <StatisticWithGraph
          description="Total Completed (Month)"
          datePeriod="month"
          teamId={teamId}
        />
      </Grid>
    </Box>
  )
}

export default Statistics
